import Params from '@/utils/types/service/urlparams';

const toQueryString = (params: Params) => {
  return Object.keys(params)
    .map(k => `?${encodeURIComponent(k)}=${encodeURIComponent(params[k].map((item) => item).join(','))}`)
    .join('&');
}

export default toQueryString;